  <button
    type="button"
    class="icon-button"
    aria-label="Account"
    [attr.aria-expanded]="open()"
    aria-haspopup="menu"
    (click)="toggle($event)"
    (mouseenter)="showTooltip.set(!open())"
    (mouseleave)="showTooltip.set(false)">
    <span class="material-symbols-outlined">account_circle</span>
  </button>

  <div
    class="user-speech-bubble"
    *ngIf="showTooltip() && !open() && (auth.isAuthenticated$ | async) && (userFullName$ | async) as fullName">
    {{ fullName }}
  </div>

  <!-- Authenticated user menu -->
  <div class="dropdown user-menu" role="menu" *ngIf="open() && (auth.isAuthenticated$ | async)">
    @if (userFullName$ | async; as fullName) {
    <div class="user-menu-header">
      <div class="user-menu-name">{{ fullName }}</div>
      @if (auth.user$ | async; as user) {
      <div class="user-menu-email">{{ user.email }}</div>
      }
    </div>
    }
    <div class="user-menu-divider"></div>
    <div class="environment-section">
      <button
        type="button"
        class="user-menu-item environment-toggle"
        (click)="toggleEnvironmentMenu($event)">
        <i class="pi pi-server menu-item-icon"></i>
        <span>Environment</span>
        <span class="environment-badge" [attr.data-env]="getCurrentEnvironment()">{{ getEnvironmentLabel(getCurrentEnvironment()) }}</span>
        <i class="pi" [class.pi-chevron-down]="!showEnvironmentMenu()" [class.pi-chevron-up]="showEnvironmentMenu()"></i>
      </button>
      @if (showEnvironmentMenu()) {
      <div class="environment-submenu">
        @for (env of getAllEnvironments(); track env.type) {
        <button
          type="button"
          class="environment-option"
          [class.active]="env.type === getCurrentEnvironment()"
          (click)="selectEnvironment(env)">
          <i class="pi" [class.pi-check]="env.type === getCurrentEnvironment()"></i>
          <span>{{ env.label }}</span>
        </button>
        }
      </div>
      }
    </div>
    <div class="user-menu-divider"></div>
    <button
      type="button"
      class="user-menu-item"
      (click)="handleLogout()">
      <i class="pi pi-sign-out menu-item-icon"></i>
      <span>Logout</span>
    </button>
  </div>

  <!-- Not authenticated - show login option -->
  <div class="dropdown user-menu" role="menu" *ngIf="open() && !(auth.isAuthenticated$ | async)">
    <div class="user-menu-header">
      <div class="user-menu-name">Session Expired</div>
      <div class="user-menu-email">Please log in to continue</div>
    </div>
    <div class="user-menu-divider"></div>
    <button
      type="button"
      class="user-menu-item login-item"
      (click)="handleLogin()">
      <i class="pi pi-sign-in menu-item-icon"></i>
      <span>Log In</span>
    </button>
  </div>
